import { ActionReducerMapBuilder, AsyncThunk, SerializedError } from '@reduxjs/toolkit';
import { Auth } from 'aws-amplify';

export enum RequestStatus {
	IDLE = 'idle',
	PENDING = 'pending',
	SUCCESS = 'success',
	ERROR = 'error'
}

export enum ProductType {
	LICENSE = 'license',
	license = 'License',
	FEATURE = 'feature'
}

export type RequestStatusObject = {
	isLoading: boolean;
	status: RequestStatus;
	error: SerializedError | null;
};

export const createRequestStatusObject = () => {
	return {
		isLoading: false,
		status: RequestStatus.IDLE,
		error: null as SerializedError | null
	};
};

export const fetchJWT = async () => {
	try {
		const currentSession = await Auth.currentSession();
		return currentSession.getIdToken().getJwtToken();
	} catch (error) {
		return '';
	}
};

export const createLazyList = () => {
	return {
		items: [],
		totalCount: 0,
		next: null
	};
};

// creates automatically the reducers
export function buildReducers<T>(
	builder: ActionReducerMapBuilder<any>,
	action: AsyncThunk<T, any, any>,
	request: string,
	options?: {
		onPending?: (state: any) => void;
		onFulfilled?: (state: any, payload: T) => void;
		onRejected?: (state: any, error: SerializedError, detailedErrorFromAPI?: any) => void;
	}
) {
	builder.addCase(action.pending, (state) => {
		state[request].error = null;
		state[request].status = RequestStatus.PENDING;
		options?.onPending && options.onPending(state);
	}),
	builder.addCase(action.fulfilled, (state, action) => {
		state[request].status = RequestStatus.SUCCESS;
		state[request].error = null;
		options?.onFulfilled && options.onFulfilled(state, action.payload);
	}),
	builder.addCase(action.rejected, (state, action) => {
		state[request].status = RequestStatus.ERROR;
		state[request].error = action.error;
		options?.onRejected && options.onRejected(state, action.error as SerializedError, action.payload);
	});
}

export const calculateAdjustedPrice = (price: number) => {
	const currentDate = new Date();
	const endOfJuly = new Date(currentDate.getFullYear(), 6, 31);
	if (currentDate > endOfJuly) {
		endOfJuly.setFullYear(currentDate.getFullYear() + 1);
	}
	const startOfLastJuly = new Date(endOfJuly.getFullYear() - 1, 6, 31);
	const totalDays = (endOfJuly.getTime() - startOfLastJuly.getTime()) / (1000 * 60 * 60 * 24);
	const currentDay = (currentDate.getTime() - startOfLastJuly.getTime()) / (1000 * 60 * 60 * 24);
	const yearProgress = currentDay / totalDays;

	return Math.round(price * (1 - yearProgress));
};
